import styled from "styled-components";

const StyledTourScheduleContainer = styled.div`
  //margin: 0 0 25% 0;
`

export {
    StyledTourScheduleContainer
}